import { Dayjs } from 'dayjs';
import { getRegion } from '@utils/misc';
import { BUSINESS_DAYS_MATRIX } from '@features/cart/const';
const isBusinessDay = (day: number) => {
  const region = getRegion('lowercase');
  const weekdays = BUSINESS_DAYS_MATRIX[region];
  return weekdays.includes(day);
};
const addBusinessDays = (number: number, date: Dayjs) => {
  const numericDirection = number < 0 ? -1 : 1;
  let currentDay = date;
  let daysRemaining = Math.abs(number);
  while (daysRemaining > 0) {
    currentDay = currentDay.add(numericDirection, 'd');
    if (isBusinessDay(currentDay.get('day'))) daysRemaining -= 1;
  }
  return currentDay;
};
export function countBusinessDays(startDate: Dayjs, endDate: Dayjs) {
  let currentDay = startDate.startOf('day');
  const endDay = endDate.startOf('day');
  let workdays = 0;

  // NOTE: skip the first day
  currentDay = currentDay.add(1, 'd');
  while (currentDay.isBefore(endDay) || currentDay.isSame(endDay)) {
    if (isBusinessDay(currentDay.get('day'))) workdays += 1;
    currentDay = currentDay.add(1, 'd');
  }
  return workdays;
}
export default addBusinessDays;